import Image from 'next/image';
import { Box } from '@mui/material';
import Link from 'next/link';

const LogoBox = ({
  megaMenuLogo,
}: {
  megaMenuLogo: { url: string; label: string | null };
}) => {
  if (!megaMenuLogo) {
    return null;
  }
  return (
    <Box
      className="md:mr-6 lg:mr-8 xl:mr-16 py-4"
      sx={{
        display: 'flex',
        alignItems: 'center',
        '& img': {
          width: '216px',
          height: '41px',
          '@media (max-width: 1280px)': {
            width: '144px',
            height: '27px',
          },
        },
      }}
    >
      <Link id="logo-box-link" href="/">
        <Image
          src={megaMenuLogo.url}
          width={216}
          height={41}
          quality={100}
          unoptimized={true}
          alt={megaMenuLogo.label || 'Boys Town National Training'}
          title={megaMenuLogo.label || 'Boys Town National Training'}
        />
      </Link>
    </Box>
  );
};

export default LogoBox;
